import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ButtonComponent,
  DropdownTriggerDirective,
  MenuItem,
  SvgIconComponent,
} from '@ui-lib/components';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '../../../core/services/language/language.service';
import { LANGUAGE_MENU_ITEMS } from './language-selector.const';
import { DEFAULT_LANGUAGE } from '../../../core/services/language/language.const';
import { Observable } from 'rxjs';

@Component({
  selector: 'rrp-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [
    CommonModule,
    ButtonComponent,
    DropdownTriggerDirective,
    SvgIconComponent,
    TranslateModule,
  ],
})
export class LanguageSelectorComponent {
  private readonly languageService = inject(LanguageService);

  public languageMenuItems: MenuItem[] = this.initLanguageMenuItems();
  public currentLanguage$: Observable<string> =
    this.languageService.getCurentLanguageObservable();

  private initLanguageMenuItems(): MenuItem[] {
    return LANGUAGE_MENU_ITEMS.map((item: MenuItem) => {
      return {
        ...item,
        callback: (): void =>
          this.languageService.setCurrentLanguage(item.id || DEFAULT_LANGUAGE),
      } as MenuItem;
    });
  }
}
